export default __webpack_public_path__ + "static/SpaceGrotesk-4168f482b9d1e040ee231632cb2b39ce.woff2";